//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
export default {
  name: 'myInvite',
  components: {
      cmBlank,cmLoadmore
  },
  data () {
    return {
      blankShow:false,
      loadStatus:false,
      loadmoreText:'正在加载。。。',
      order:'total_amount',
      active:0,
      nav:[
          {
            key:'total_amount',
            title:'累计营业额'
          },
          {
            key:'total_reward',
            title:'累计返佣'
          },
          {
            key:'month_amount',
            title:'当月营业额'
          },
          {
            key:'month_reward',
            title:'当月返佣'
          },
      ],
      list:[],
    }
  },
  created(){
      this.getList();
  },
  amount(){
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.getList();
    },
    orderSort(index){
        this.active = index;
        this.order = this.nav[index].key;
        this.list = [];
        this.getList();
    },
    getList(){
        this.$api.myInvite({last_id:this.lastId,page_flag:this.pageFlag,order:this.order}).then((res)=>{
          if(res){
            // console.log(res);
            if(!this.lastId){
                this.blankShow = res.data.length > 0 ? false : true;
            }
            this.hasNext = res.hasNext;
            this.lastId = res.lastId;
            this.list = res.data;
          }
        })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/myInvite.vue